const moveTo = (obj, ctxt, x, y) => {
    ctxt.moveTo(x,y);
};

const lineTo = (obj, ctxt, x, y) => {
    ctxt.lineTo(x,y);
};

const beginPath = (obj, ctxt) => {
    ctxt.beginPath();
};
const closePath = (obj, ctxt) => {
    ctxt.closePath();
};

const fill = (obj, ctxt, color) => {
    ctxt.fillStyle = color;
    ctxt.fill();
};

const clear = (obj, ctxt) => {
    ctxt.clearRect(0,0,obj.zObject.width*2, obj.zObject.height*2);
    //ctxt.rect(0,0,obj.zObject.width*2, obj.zObject.height*2);
    //ctxt.clip();
};

const stroke = (obj, ctxt, color) => {
    ctxt.strokeStyle = color;
    ctxt.stroke();
};

const rect = (obj, ctxt, x, y, w, h) => {
    ctxt.beginPath();
    ctxt.rect(x,y,w,h);
}

const lineWidth = (obj, ctxt, width) => {
    ctxt.lineWidth = width;
}

const circle = (obj, ctxt, x, y, radius, startDeg=0, endDeg=2*Math.PI) => {
    ctxt.beginPath();
    if (radius > 0) {
        ctxt.arc(x,y,radius,startDeg,endDeg);
    }
};


const triangle = (obj, ctxt, x1, y1, x2, y2, x3, y3) => {
    ctxt.beginPath();
    ctxt.moveTo(x1, y1);
    ctxt.lineTo(x2, y2);
    ctxt.lineTo(x3, y3);
    ctxt.closePath();
};

export const core = {
    moveTo,
    clear,
    rect,
    lineTo,
    beginPath,
    closePath,
    circle,
    stroke,
    lineWidth,
    fill,
    triangle,
};
